export const isPolicyDraftValid = (values) => {
  const decimal = /^\d{1,14}(?:\.\d{1,6})?$/;
  return (
    decimal.test(values.activeRate) &&
    decimal.test(values.inactiveRate) &&
    /^[A-Z]{3}$/.test(values.currency) &&
    Number.isInteger(Number(values.count)) &&
    Number(values.count) >= 1 &&
    Number(values.count) <= 120 &&
    ['month', 'year', 'week', 'day'].includes(values.unit) &&
    ['next_uninvoiced_term', 'launch_zero', 'new_contract'].includes(values.effectiveKind) &&
    /^\d{4}-\d{2}-\d{2}$/.test(values.effectiveTerm) &&
    !Number.isNaN(Date.parse(values.effectiveTerm)) &&
    new Date(values.effectiveTerm).toISOString().slice(0, 10) === values.effectiveTerm &&
    (values.effectiveKind !== 'launch_zero' || Number(values.inactiveRate) === 0)
  );
};
